import { put, select, take } from 'redux-saga/effects';

import ActionTypesCabinet from 'containers/Configurator/constants/furniture';
import ActionTypesSelection from 'containers/Configurator/constants/selection';
import { makeSelectShelvesSelectedLastCabinet } from 'containers/Configurator/selectors/selection';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { makeSelectShelfSelectionProfile } from 'containers/Ribbon/ShelvesRibbon/selectors';
import { ShelfSelection } from 'lib/modelBuilder/entities/ShelfSelection';
import { updateProfileSelectionAction } from 'containers/Ribbon/ShelvesRibbon/actions';

export default function* deleteProfileSelectionSaga(): any {
  while (true) {
    yield take([
      ActionTypesCabinet.CABINET_UPDATE_SUCCESS,
      ActionTypesSelection.ADD_TO_SHELVES_SELECTION,
      ActionTypesSelection.SHELVES_SELECTION,
    ]);

    const selectedShelves: Shelf[] = yield select(
      makeSelectShelvesSelectedLastCabinet(),
    );

    const shelfSelectionProfile: ShelfSelection = yield select(
      makeSelectShelfSelectionProfile(),
    );
    shelfSelectionProfile.update(selectedShelves);

    yield put(updateProfileSelectionAction(shelfSelectionProfile));
  }
}
